var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    transform: "matrix(-1 0 0 -1 800 800)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 597.5,
    cy: -77,
    rx: 604.5,
    ry: 450,
    transform: "rotate(-180 597.5 -77)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 612.5,
    cy: 934,
    rx: 638.5,
    ry: 450,
    transform: "rotate(-180 612.5 934)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white",
    transform: "matrix(-1 0 0 -1 800 800)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundHero);
export default __webpack_public_path__ + "static/media/background-hero.56bcc2e6d6d625f522f9402aa79470cb.svg";
export { ForwardRef as ReactComponent };